import * as React from "react";

import primaryColour from "../../constants";

function SvgTrailerattached(props: React.SVGProps<SVGSVGElement>) {
  const { fill = primaryColour } = props;
  return (
    <svg width={24} height={25} viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M21.9506 13.7917C21.9833 13.4628 22 13.1292 22 12.7917C22 12.4542 21.9833 12.1207 21.9506 11.7917H15.7683C15.3708 11.7917 15.0247 11.5437 14.7767 11.2331C14.3186 10.6594 13.6132 10.2917 12.822 10.2917C11.4412 10.2917 10.322 11.411 10.322 12.7917C10.322 14.1725 11.4412 15.2917 12.822 15.2917C13.6132 15.2917 14.3186 14.9241 14.7767 14.3504C15.0247 14.0398 15.3708 13.7917 15.7683 13.7917H21.9506Z"
        fill={fill}
      />
      <path
        d="M2.11175 11.2917C2.03815 11.781 2 12.2819 2 12.7917C2 13.3016 2.03815 13.8025 2.11175 14.2917H5.28516C5.74888 14.2917 6.14409 14.614 6.30513 15.0489C7.22249 17.5261 9.60631 19.2917 12.4025 19.2917C13.4303 19.2917 14.405 19.0525 15.2714 18.6257C15.7669 18.3817 15.9707 17.7822 15.7267 17.2868C15.4826 16.7913 14.8832 16.5875 14.3877 16.8316C13.7901 17.1259 13.1171 17.2917 12.4025 17.2917C9.91725 17.2917 7.90253 15.277 7.90253 12.7917C7.90253 10.3065 9.91725 8.29175 12.4025 8.29175C13.0234 8.29175 13.6126 8.41694 14.148 8.6425C14.6569 8.85692 15.2434 8.61815 15.4578 8.10919C15.6722 7.60023 15.4334 7.01381 14.9245 6.79939C14.1477 6.47214 13.2949 6.29175 12.4025 6.29175C9.60631 6.29175 7.22249 8.05739 6.30513 10.5346C6.14409 10.9695 5.74888 11.2917 5.28516 11.2917H2.11175Z"
        fill={fill}
      />
    </svg>
  );
}

export default SvgTrailerattached;
